<template>
  <div class="otp-email">
    <div class="title">تایید کد</div>
    <div class="timer">
      <p class="text-info">کد ارسال شده به ایمیل خود را وارد کنید</p>
      <span v-if="finished">0:00</span>
      <span v-else>{{display}}</span>
    </div>
     <div class="email">
       <img src="../../assets/icon/email.png" alt="">
       <span>{{ state.userInfo.email }}</span>
     </div>
<div class="code-input" @paste="paste">
  <label >کدارسالی:</label>
  <CodeInput
      class="code-input"
      @change="onChange"
      @complete="submit"
      :fields="num"
      ref="code-input"
  />
</div>
    <button v-if="!finished" @click.prevent="submit" class="blue-btn"> تایید</button>
    <button v-if="finished" @click.prevent="resetCode" class="blue-btn">ارسال مجدد</button>
  </div>
</template>

<script>
import {paste} from '../../lib/reuseableFunction'
import CustomInput from "../tools/custom-input";
import CodeInput from 'vue-verification-code-input'
import { DateTime, Duration } from "luxon";
export default {
  name: "otp-email",
  data() {
    return {
      //timer
      now: DateTime.local().set({ milliseconds: 0 }),
      end: DateTime.local().set({ milliseconds: 0 }).plus({ seconds: 120 }),
      tick: null,
      num: 6,
      //otp
      otp: {
        code: "",
        email: this.state.userInfo.email || this.$cookies.get("username"),
        mobile: this.state.userInfo.mobile,
        // google: this.state.userInfo.google,
      },
    };
  },
  watch: {
    now() {
      if (this.finished) {
        clearInterval(this.tick);
      }
    },
  },
  computed: {
    remaining() {
      return this.end.diff(this.now).toObject();
    },
    display() {
      return Duration.fromObject(this.remaining).toFormat("mm:ss");
    },
    finished() {
      return this.now >= this.end;
    },
  },
  mounted() {

    this.tick = setInterval(() => {
      this.now = DateTime.local().set({ milliseconds: 0 });
    }, 1000);
    if (!this.otp.email) {
      this.$router.push("/login");
    }
    if (this.state.towStepAuthenticationType !== "GOOGLE_AUTHENTICATOR") {
      this.now = DateTime.local().set({ milliseconds: 0 });
      this.end = DateTime.local()
          .set({ milliseconds: 0 })
          .plus({ seconds: 120 });
      this.tick = setInterval(() => {
        this.now = DateTime.local().set({ milliseconds: 0 });
      }, 1000);
    }
  },
  methods: {
    paste,
    onChange(e) {
      this.otp.code = e;
    },
    async submit() {
      this.disablebtn = false;
      if (!this.finished) {
        this.state.loading = true;
        const res = await this.$axios.post("/users/check-otp-code", this.otp);
        if (res.token) {
          await this.$setToken(res.token);

          await !this.state.userInfo.authorized? this.$router.push("/thekyc"): this.$router.push("/panel");
        }
      }
    },
    async resetCode() {
      this.state.loading = true;
      await this.$axios.post(
          `/users/resend-otp-code?email=${this.$cookies.get("username")}`
      );
      this.$error("کد جدید  " + "  ارسال شد.", "", "success");
      this.$cookies.set("username", this.state.userInfo.email);

      //codes that will reset our code
      if (this.now >= this.end) {
        this.now = DateTime.local().set({ milliseconds: 0 });
        this.end = DateTime.local()
            .set({ milliseconds: 0 })
            .plus({ seconds: 120 });
        this.tick = setInterval(() => {
          this.now = DateTime.local().set({ milliseconds: 0 });
        }, 1000);
      }

      // this.state.loading = true
      // this.otp.code = ''
      // await this.$axios.post(`/users/resend-otp-code?email=${this.$cookies.get('username')}`)
      // this.$error('کد جدید  ' +'  ارسال شد.', '', 'success')
      // this.$cookies.set('username', this.state.userInfo.email)
      // if (this.pathMatch !== 'google-auth') {
      //   if (this.now >= this.end) {
      //     console.log('hi')
      //
      //   }
      // }
    },
  },
  components: {CustomInput,CodeInput}
}
</script>

<style lang="scss" scoped>
.code-input{
  display: flex;
  flex-direction: column;
  label{
    display: flex;
    align-self: flex-start;
    font-size: clamp(10px , 2vw , 12px);
  }
}
.otp-email {
  display: flex;
  flex-direction: column;
  gap: 30px;
  direction: rtl;
  color: #FBFBFD;
  justify-content: center;
  align-items: center;

  .email{
    display: flex;
    width: 100%;
    flex-direction: row;
    gap: 10px;
    font-size: clamp(10px , 2vw , 12px);
    img{
      width: 16px;
      height: 13px;
    }
  }

  .timer{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
    align-items: center;

    span{
      color: #1199FA;
    }
  }

  .title{
    font-size: clamp(18px , 2vw , 22px);
    font-weight: bold;
  }

  .text-info{
    font-size: clamp(12px , 2vw , 14px);
    text-align: right;
    width:100%;
  }

  button{
    width: 100%;
  }

  label{
    position: relative;
    width: 100%;
    img{
      position: absolute;
      left: 16px;
      top: 35%;
    }
  }
}
</style>
<style lang="scss">
.react-code-input-container {
  margin: auto;
  width: 25vw;
  min-width: 180px;
  direction: ltr !important;
  max-width: 348px !important;
  width: 80vw !important;
  background: transparent;
  border: 0.5px solid #279bc0;
  box-sizing: border-box;
  border-radius: 4px;
}
.react-code-input {
  display: flex;
  justify-content: space-around;
  height: 44px !important;
  input {
    max-width: 35px !important;
    border: none !important;
    border-bottom: 1px solid #c4c4c4 !important;
    border-radius: 0 !important;
    height: 32px !important;
    background-color: transparent;
    color: #f2f2f2 !important;
  }
}

@media(max-width: 500px){
  .react-code-input-container {
    max-width: 280px !important;
  }
}
</style>